import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconCty from '../build/icon-cyt'

export const IconCyt: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconCty} />
}

export default IconCyt
